// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1368":"392ba6701f265719","5364":"f53f73e0021575ef","6681":"89986b5dbb738bbf"}[chunkId] + ".js";
};